export interface DireccionProvincialItem {
  name: string;
  address: string;
  phone: string;
  email?: string;
}

export interface DireccionProvincial {
  province: string;
  items: DireccionProvincialItem[];
}

export const DIRECCIONES_PROVINCIALES: DireccionProvincial[] = [
  {
    province: 'Toledo',
    items: [
      {
        name: 'Sede Central',
        address: 'C/ Berna, 1. 45003. Toledo',
        phone: '925 28 31 86',
      },
      {
        name: 'Hospital Solimat San Jose',
        address: 'San Pedro el Verde, 35. 45004. Toledo',
        phone: '925 21 52 67',
      },
      {
        name: 'Direccion Provincial de Toledo',
        address: 'C/ Berna, 1. 45003. Toledo',
        phone: '925 28 37 77',
        email: 'toledo@solimat.com',
      },
      {
        name: 'Direccion de Illescas y Talavera de la Reina - Centro Asistencial Illescas',
        address: 'Ctra. Ugena, 2 "Edificio Trebol". 45200. Illescas - Toledo',
        phone: '925 54 21 27',
        email: 'illescas@solimat.com',
      },
      {
        name: 'Centro Asistencial Talavera de la Reina',
        address: 'Calle Calera, s/n. 45600. Talavera de la Reina - Toledo',
        phone: '925 72 11 50',
        email: 'talavera@solimat.com',
      },
    ],
  },
  {
    province: 'Albacete',
    items: [
      {
        name: 'Direccion Provincial de Albacete',
        address: 'Parque Empresarial Campollano 5a Avenida, n.o 13 y 15. 02007 Albacete',
        phone: '967 51 14 17',
        email: 'albacete@solimat.com',
      },
    ],
  },
  {
    province: 'Ciudad Real',
    items: [
      {
        name: 'Direccion Provincial de Ciudad Real',
        address: 'Calle Alfonso Eanes, 3. 13005. Ciudad Real',
        phone: '926 271 131',
        email: 'ciudadreal@solimat.com',
      },
      {
        name: 'Centro Administrativo Alcazar de San Juan',
        address: 'C/ Paseo de la Estacion, 24 - Bajo. 13600. Alcazar de San Juan - Ciudad Real',
        phone: '926 44 80 45',
        email: 'ciudadreal@solimat.com',
      },
    ],
  },
  {
    province: 'Cuenca',
    items: [
      {
        name: 'Direccion Provincial de Cuenca',
        address: 'Calle Clara Campoamor, 2-F. 16003. Cuenca',
        phone: '969 23 60 01',
        email: 'cuenca@solimat.com',
      },
    ],
  },
  {
    province: 'Guadalajara',
    items: [
      {
        name: 'Direccion Provincial de Guadalajara',
        address: 'Avda. Francia, 5 Locales 7-8. 19005. Guadalajara',
        phone: '949 36 40 06',
        email: 'guadalajara@solimat.com',
      },
    ],
  },
  {
    province: 'Madrid',
    items: [
      {
        name: 'Direccion Provincial de Madrid',
        address: 'C/ Irene Joliot Curie, 2 (P.I. San Marcos). 28906. Getafe - Madrid',
        phone: '91 665 36 80',
        email: 'madrid@solimat.com',
      },
    ],
  },
];
